import React from 'react';
import { connect } from 'react-redux';
import ClassificationComponent from '@/containers/CampaignDetail/Classification/Classification';
import Notes from '@/containers/SubCampaignDetail/Notes/Notes';
import { TABS } from '@/helpers/constants';
import { getIsVANCR } from '@/redux/Campaign/campaign.reducer';
import { setSubCampaignClassificationNotes, setSubCampaignOriginalValues } from '@/redux/SubCampaign/subCampaign.action';
import { getSubcampaignClassificationNotes, getSubCampaignOriginalValues } from '@/redux/SubCampaign/subCampaign.reducer';
import { OriginalValues } from '@/types';

interface ClassificationProps {
  setClassificationNotes: (notes: string[]) => void;
  classificationNotes: string[];
  setOriginalValues: (values: OriginalValues) => void;
  originalValues: OriginalValues;
  isVANCR: boolean;
}

const Classification: React.FC<ClassificationProps> = (props) => {
  const { setClassificationNotes, classificationNotes, setOriginalValues, originalValues, isVANCR } = props;

  const onSetOriginValues = () => {
    const values = {
      ...originalValues,
      hasChange: true,
    };
    setOriginalValues(values);
  };

  const addNotes = () => {
    setClassificationNotes([...classificationNotes, '']);
  };

  const handleChangeText = (comment: string, id: number) => {
    const newState = [...classificationNotes];
    newState.splice(id, 1, comment);
    setClassificationNotes(newState);
    onSetOriginValues();
  };

  return (
    <>
      <ClassificationComponent subCR />
      {!isVANCR && (<Notes isMandatory notes={classificationNotes} addNotes={addNotes} handleChangeText={handleChangeText} tab={TABS.classification.label} />)}
    </>
  );
};

const mapStateToProps = (state) => ({
  classificationNotes: getSubcampaignClassificationNotes(state),
  originalValues: getSubCampaignOriginalValues(state),
  isVANCR: getIsVANCR(state),
});

const actionCreators = {
  setClassificationNotes: setSubCampaignClassificationNotes,
  setOriginalValues: setSubCampaignOriginalValues,
};

export default connect(mapStateToProps, actionCreators)(Classification);
